/**
 * Menghitung periode akuntansi (YYYY-MM).
 * Jika tanggal > 30, maka dianggap masuk ke periode bulan berikutnya.
 */
export function getAccountingPeriod(dateStr: string) {
  const d = new Date(dateStr);
  const day = d.getDate();

  // Cut-off: Tanggal 31 masuk ke bulan depan
  if (day > 30) {
    d.setMonth(d.getMonth() + 1);
  }

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');

  return `${year}-${month}`;
}
